export default __webpack_public_path__ + "static/media/dopaminergic-diagram.8dce2fb0.svg";